export const I18n = {
	'en': {
		pointsListTitle: 'Trader points list',
		searchPlaceholder: 'Search by name',
		add: 'Add point',
		traiderPoint: 'Trader point',
		member: 'Member',
		contacts: 'Contacts',
		city: 'City',
		status: 'Status',
		statusPending: 'Pending',
		statusBlocked: 'Blocked',
		statusActive: 'Active',
		noStatus: 'None',
		show: 'Show...',
		hide: 'Hide...',
        lastActivity: 'Last Active',
		wifi: 'Wi-Fi',
		operators: 'Operators',
	},
	'ru': {
		pointsListTitle: 'Список торговых точек',
		searchPlaceholder: 'Поиск по названию',
		add: 'Добавить',
		traiderPoint: 'Торговая точка',
		member: 'Cотрудник',
		contacts: 'Контакты',
		city: 'Город',
		status: 'Статус',
		statusPending: 'В ожидании',
		statusBlocked: 'Заблокирован',
		statusActive: 'Активный',
		noStatus: 'Не назначен',
		show: 'Показать...',
		hide: 'Скрыть...',
        lastActivity: 'Активность',
		wifi: 'Wi-Fi',
		operators: 'Операторы',
	},
	'sk': {
		pointsListTitle: 'Zoznam obchodník body',
		searchPlaceholder: 'Vyhľadávanie podľa mena',
		add: 'Pridať bod',
		traiderPoint: 'Trader bod',
		member: 'člen',
		contacts: 'Kontakty',
		city: 'Veľkomesto',
		status: 'Postavenie',
		statusPending: 'Nevykonaného',
		statusBlocked: 'Upchatý',
		statusActive: 'Aktívny',
		noStatus: 'Nikto',
		show: 'Show...',
		hide: 'Skryť...',
		lastActivity: 'Aktivita',
		wifi: 'Wi-Fi',
		operators: 'Operators',
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/storesList/index.js